import ClientDetails from '@modules/clients/presentation/v1/pages/Details';
import { createRoute, Outlet } from '@tanstack/react-router';
import { layoutRoute } from '@app/router/layout';
import { ClientsListPage } from '@modules/clients/presentation/v2/pages/List';

export const ClientsLayoutRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/clients',
  beforeLoad: () => ({ featureName: 'clients.module' }),
  component: () => <Outlet />,
});

export type ClientsListSearchQuery = {
  // Start Date Range
  sdr?: string;
  // End Date Range
  edr?: string;
  stage?: string;
  order?: string;
  sort?: string;
  page?: number;
  q?: string;
};

export const ClientsRoute = createRoute({
  getParentRoute: () => ClientsLayoutRoute,
  path: '/',
  beforeLoad: () => ({ breadcrumb: { key: 'clientListing' } }),
  component: () => (
    <ClientsListPage />
  ),
  validateSearch: (search: Record<keyof ClientsListSearchQuery, any>): ClientsListSearchQuery =>
    ({
      sdr: search.sdr || '',
      edr: search.edr || '',
      stage: search.stage || '',
      sort: search.sort || '',
      order: search.order || '',
      page: search.page || 1,
      q: search.q || '',
    })
  ,
});

export type ClientDetailsSearchQuery = {
  completeClient?: boolean | string;
  tab?: string;
  application?: string;
};

export const ClientDetailsRoute = createRoute({
  getParentRoute: () => ClientsLayoutRoute,
  path: '/$id',
  beforeLoad: () => ({ breadcrumb: { key: 'clientListing.clientDetail' } }),
  component: () => (
    <ClientDetails />
  ),
  validateSearch:
    (search: Record<keyof ClientDetailsSearchQuery, any>): ClientDetailsSearchQuery =>
      ({ tab: search.tab || '', completeClient: search.completeClient || '' }),
});
